var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "16", height: "9", viewBox: "0 0 16 9", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.09497 0.312553C1.56995 -0.146834 0.771939 -0.0936332 0.312552 0.43138C-0.146835 0.956394 -0.0936335 1.75441 0.43138 2.21379L7.16821 8.10852C7.64445 8.52523 8.35555 8.52523 8.83179 8.10852L15.5686 2.21379C16.0936 1.75441 16.1468 0.956393 15.6874 0.431379C15.2281 -0.0936345 14.43 -0.146835 13.905 0.312552L8 5.47946L2.09497 0.312553Z", fill: "#303030" })
  );
});